import { useEffect, useMemo, useState } from "react";

// [[Catalog Assets]] #obsidian-marker
export default function useCatalogAssetAvailability(rows, enabled, includeCards = false) {
    const parts = useMemo(() => JSON.stringify([...new Set(rows.map(row => row.name?.trim()).filter(Boolean))].sort()), [rows]);
    const [state, setState] = useState({ parts: null, materials: {}, error: false });
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (!enabled) return undefined;
        const controller = new AbortController();
        setState({ parts, materials: {}, error: false });
        const load = async () => {
            const list = JSON.parse(parts);
            const materials = Object.create(null);
            for (let index = 0; index < list.length; index += 200) {
                const response = await fetch(`/api/components/assets/availability${includeCards ? "?includeCards=true" : ""}`, {
                    method: "POST", headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(list.slice(index, index + 200)), signal: controller.signal,
                });
                if (!response.ok) throw new Error("Catalog unavailable");
                for (const material of await response.json()) {
                    (materials[material.part_number] ||= []).push(material);
                }
            }
            if (!controller.signal.aborted) setState({ parts, materials, error: false });
        };
        load().catch(() => {
            if (!controller.signal.aborted) setState({ parts, materials: {}, error: true });
        });
        return () => controller.abort();
    }, [parts, enabled, attempt, includeCards]);
    return {
        materials: enabled && state.parts === parts ? state.materials : {},
        error: enabled && state.parts === parts && state.error,
        retry: () => setAttempt(value => value + 1),
    };
}
